import { del, get, post, put } from "./api_helper"
import { getAccessToken } from "./jwt-token-access/accessToken"

const API_BASE_URL = `${process.env.REACT_APP_API_INT_LEADS}/api`

// Criar vínculo
export const createVinculo = (
  Id_EmpresaMonitorada,
  Id_Parceiro
) => {
  return post(
    `${API_BASE_URL}/empresas-monitoradas/vinculos`,
    {
      Id_EmpresaMonitorada,
      Id_Parceiro: Id_Parceiro || null,
    },
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  )
}

// Listar vínculos de uma empresa
export const getVinculosByEmpresa = empresaId => {
  return get(`${API_BASE_URL}/empresas-monitoradas/${empresaId}/vinculos`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
}

// Atualizar vínculo
export const updateVinculo = (
  vinculoId,
  Id_Parceiro,
  Status
) => {
  return put(
    `${API_BASE_URL}/empresas-monitoradas/vinculos/${vinculoId}`,
    {
      Id_Parceiro: Id_Parceiro || null,
      Status,
    },
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  )
}

// Remover vínculo
export const deleteVinculo = vinculoId => {
  return del(`${API_BASE_URL}/empresas-monitoradas/vinculos/${vinculoId}`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  })
}

